// globals.js — MUST be imported FIRST, before any screen module.
//
// The Claude Design prototype was written as ordered <script> tags where
// React, ReactDOM, and the screen components all live on `window.*`. We port
// the prototype dialect VERBATIM (the user's locked decision: export→drop
// near-literal) by recreating those globals here instead of rewriting every
// file to ESM imports.
//
// Why a SEPARATE module (not inline in main.jsx): ES module imports are
// hoisted and execute before any statement in the importing module's body.
// If `window.React = React` lived in main.jsx alongside `import './screens/…'`,
// the screen modules would execute (referencing window.React) BEFORE the
// assignment ran → undefined. A dedicated module imported first guarantees the
// globals are set before any screen module is evaluated, because sibling
// imports execute in source order, each fully before the next.
import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { createPortal } from 'react-dom';

window.React = React;            // screens use `const { useState } = React`
// app.jsx uses ReactDOM.createRoot(); modal screens (admin/profile/reportissue/
// login/feedback/jobdetail) use ReactDOM.createPortal(). createPortal lives in
// the base react-dom package, not /client — so we splice both onto window.
window.ReactDOM = { ...ReactDOMClient, createPortal };
